import { StopOutlined } from 'opencare-crown';

import DoctorFemale from '../../../common/icons/DoctorFemale';
import DoctorMale from '../../../common/icons/DoctorMale';

export const options = [
  {
    id: 'M',
    title: 'I prefer a male',
    icon: DoctorMale,
  },
  {
    id: 'F',
    title: 'I prefer a female',
    icon: DoctorFemale,
  },
  {
    id: 'not-important',
    title: 'Not important to me',
    icon: StopOutlined,
  },
];
